import type { BoxProps, FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';
import type { MotionProps } from 'framer-motion';

import MotionBox from '../MotionBox/MotionBox';

type Props = {
  size?: number;
};

export const Spinner = ({ size = 12, ...rest }: Props & FlexProps) => {
  const getPxValue = (value: number) => `${value}px`;

  const stylingProps: Omit<BoxProps, 'transition'> & MotionProps = {
    width: getPxValue(size),
    height: getPxValue(size),
    borderRadius: 'full',
    pos: 'absolute',
    transition: {
      duration: 3,
      repeat: Infinity,
      easings: 'ease',
    },
  };

  return (
    <Flex
      flexDirection='row'
      pos='relative'
      width={getPxValue(size * 3)}
      height={getPxValue(size)}
      {...rest}>
      <MotionBox
        backgroundColor='secondary400'
        {...stylingProps}
        animate={{
          scale: [1, 0, 1, 1.4, 1],
          translateX: [
            getPxValue(0),
            getPxValue(size),
            getPxValue(size * 2),
            getPxValue(size),
            getPxValue(0),
          ],
        }}
      />
      <MotionBox
        backgroundColor='primary400'
        {...stylingProps}
        zIndex={10}
        animate={{
          scale: [1, 1.4, 1, 0, 1],
          translateX: [
            getPxValue(size * 2),
            getPxValue(size),
            getPxValue(0),
            getPxValue(size),
            getPxValue(size * 2),
          ],
        }}
      />
    </Flex>
  );
};
